import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { inject, Injectable } from "@angular/core";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { AvatarService } from "src/app/services/avatar.service";
import { lastValueFrom } from "rxjs";
import { getPublicFileSrcById } from "src/app/support/public-file";

@Injectable()
export class ProvideAvatarGuard {
  private memberBacked = inject(MemberBackend);
  private avatarService = inject(AvatarService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const members: any = await lastValueFrom(
      this.memberBacked.listActiveAllLight()
    );

    for (const member of members) {
      if (member.user?.avatar) {
        const url = <string>getPublicFileSrcById(member!.user!.avatar, {
          noCache: true
        });

        this.avatarService.register(member.id, url);
      }
    }

    return true;
  }
}
